<template>
  <div>
    <HeadBanner :itemData="$store.state.selected_menu" />
    <Breadcrumb />
    <WidgetSlider />
    <ServiceSlider
      v-if="
        _.get(
          this.$store.state.current_content,
          'secondary.ServiceSlider.conf.enabled'
        ) == 1
      "
      :itemData="
        _.get(this.$store.state.current_content, 'secondary.ServiceSlider')
      "
    />
    <CardSlider
      v-if="
        _.get(
          this.$store.state.current_content,
          'secondary.CardSlider.conf.enabled'
        ) == 1
      "
      :itemData="
        _.get(this.$store.state.current_content, 'secondary.CardSlider')
      "
    />
    <UsefulTools
      :itemData="
        _.get(this.$store.state.current_content, 'secondary.usefull_tools.conf')
      "
      v-if="
        _.get(
          this.$store.state.current_content,
          'secondary.usefull_tools.conf.enabled'
        ) == 1
      "
      :firstLook="4"
      :ipadLook="2.5"
    />
    <ProductsSlider
      class="change-pad"
      v-if="
        _.get(
          this.$store.state.current_content,
          'secondary.ProductsSlider.conf.enabled'
        ) == 1
      "
      :itemData="
        _.get(this.$store.state.current_content, 'secondary.ProductsSlider')
      "
    />
    <MoreWaysForBanking class="change-pad" />
<!--     <CalculatorCurrency/> -->
  </div>
</template>


<script>
import HeadBanner from "@/components/HeadBanner";
import Breadcrumb from "@/components/Breadcrumb";
const WidgetSlider = () => import( "@/components/WidgetSlider")
// import WidgetSlider from "@/components/WidgetSlider";
import ServiceSlider from "@/components/ServiceSlider";
import CardSlider from "@/components/CardSlider";
import UsefulTools from "@/components/UsefulTools";
import ProductsSlider from "@/components/ProductsSlider";
import MoreWaysForBanking from "@/components/MoreWaysForBanking";
import CalculatorCurrency from "@/components/CalculatorCurrency";

export default {
  components: {
    HeadBanner,
    Breadcrumb,
    WidgetSlider,
    ServiceSlider,
    CardSlider,
    UsefulTools,
    ProductsSlider,
    MoreWaysForBanking,
    CalculatorCurrency
  },
};
</script>
